import React, { useState, useEffect, useCallback }  from "react";
import { Howl } from "howler";

function Result({ score, totalQuestions, isMuted }) {
  const handleDownload = () => {
    const link = document.createElement('a');
    link.href = '/pdf/BADGE_75CM.pdf';
    link.download = 'BADGE_75CM.pdf';
    link.click();
  };

  const [sound, setSound] = useState(null);
  
    const stopSound = () => {
      if (sound) {
        sound.stop();
        setSound(null);
      }
    };
  
    useEffect(() => {
      updateAudioSource();
    }, [isMuted]);
  
    const updateAudioSource = useCallback(() => {
      stopSound();
      const newSound = new Howl({
        src: ["/audio/Felicitations.mp3"],
        volume: 1,
        onplay: () => console.log("Lecture audio démarrée"),
        onend: () => {
          console.log("Lecture audio terminée");
        },
      });
      newSound.play();
      newSound.mute(isMuted);
      setSound(newSound);
    }, [isMuted, sound]);
  

  return (
    <div className="row flex-grow-1">
      <div className="col-12 col-md-6 d-flex flex-column px-3 px-md-5 border-md-end">
        <div className="big-text text-break" style={{ fontFamily: "Caveat" }}>
          Félicitations !
        </div>
        <div className="flex-grow-1"></div>
        <div className="text-center d-none d-md-block">
          <img src="/img/result.png" alt="question" className="img-fluid" />
        </div>
      </div>
      <div className="col-12 col-md-6 px-3 px-md-5">
        <div className="fw-bold my-4" style={{ fontSize: "20px", lineHeight: "25px" }}>
        Tu as fini le Permis Jeune Mobilité ! On se retrouve dans le bus alors, et si tu veux récupérer ton badge physiquement, rendez-vous à l’agence commerciale de ton réseau.
        </div>
        <button type="button" onClick={handleDownload} className="mybutton sapin w-100 mt-5">
          Télécharger mon badge
        </button>
      </div>
    </div>
  );
}

export default Result;
